import React from "react";
import { Box, Typography } from "@mui/material";
import ExperienceImg1 from "../assests/experience1.avif";
import ExperienceImg2 from "../assests/experience2.avif";
import ExperienceImg3 from "../assests/experience3.avif";
import { useMediaQuery, useTheme } from "@mui/material";

const Experience = () => {
    const theme = useTheme();
    const isBig = useMediaQuery(theme.breakpoints.down(1250));
    const isMobile = useMediaQuery(theme.breakpoints.down(890));
    const isSmall = useMediaQuery(theme.breakpoints.down(450));

    const styles = {
        container: {
            flex: 1
        },
    };

    return (
        <Box sx={styles.container}>
            <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', marginTop: isSmall ? 5 : 10 }}>
                <Typography variant={isMobile ? "h5" : "h3"} fontWeight="bold" style={{ width: isMobile ? '100%' : isBig ? '60%' : '45%', textAlign: 'center' }} >
                    It's just not all about results, Experience does matters
                </Typography>
                <Typography variant="body1" style={{ width: isMobile ? '100%' : isBig ? '60%' : '30%', textAlign: 'center', marginTop: 20 }}>
                    Imagine working with a partner that makes sure your experience besides results are top-notch
                </Typography>
            </Box>


            <Box style={{ width: isMobile ? '100%' : '80%', margin: '0px auto', marginTop: isSmall ? 50 : 80, display: 'flex', flexDirection: isMobile ? 'column' : 'row', justifyContent: 'center', flexWrap: 'wrap' }}>
                <Box style={{ width: isMobile ? '90%' : isBig ? '49%' : '32%', margin: '50px auto', display: 'flex', justifyContent: 'center' }}>
                    <Box
                        sx={{
                            border: "1px solid #d0d0d0",
                            borderRadius: "20px",
                            padding: isSmall ? "30px 30px" : "30px 50px",
                            boxSizing: "border-box",
                            position: "relative",
                        }}
                    >
                        <Box
                            component="img"
                            src={ExperienceImg1}
                            alt="Step 02"
                            sx={{
                                position: "absolute",
                                top: "-45px",
                                left: "150px",
                                width: "50px",
                                height: "50px",
                                background: 'rgb(255, 210, 48)',
                                borderRadius: "50%",
                                padding: "15px 15px",
                            }}
                        />
                        <h3>In-House Like Communication</h3>
                        <div style={{ lineHeight: '2' }}>
                            Get your own dedicated Slack channel to stay   connected with our marketing team. With twice-a-week reports, monthly creative analysis & consumer insights, on-demand consulting calls, and more, tweaked to your liking. We're just a text away whenever you need help!
                        </div>
                    </Box>
                </Box>

                <Box style={{ width: isMobile ? '90%' : isBig ? '49%' : '32%', margin: '50px auto', display: 'flex', justifyContent: 'center' }}>

                    <Box
                        sx={{
                            border: "1px solid #d0d0d0",
                            borderRadius: "20px",
                            padding: isSmall ? "30px 30px" : "30px 50px",
                            boxSizing: "border-box",
                            position: "relative",
                        }}
                    >
                        <Box
                            component="img"
                            src={ExperienceImg2}
                            alt="Step 02"
                            sx={{
                                position: "absolute",
                                top: "-45px",
                                left: "150px",
                                width: "50px",
                                height: "50px",
                                background: 'rgb(255, 210, 48)',
                                borderRadius: "50%",
                                padding: "15px 15px",
                            }}
                        />
                        <h3>Better DTC Landscape Understanding </h3>
                        <div style={{ lineHeight: '2' }}>
                            Coming from running our own eCommerce brand, we truly grasp the inner workings of the business from the founder's standpoint. The data we gather isn't just about numbers; we help brand owners understand it to improve their business every month.
                        </div>
                    </Box>
                </Box>

                <Box style={{ width: isMobile ? '90%' : isBig ? '49%' : '32%', margin: '50px auto', display: 'flex', justifyContent: 'center' }}>

                    <Box
                        sx={{
                            border: "1px solid #d0d0d0",
                            borderRadius: "20px",
                            padding: isSmall ? "30px 30px" : "30px 50px",
                            boxSizing: "border-box",
                            position: "relative",
                        }}
                    >
                        <Box
                            component="img"
                            src={ExperienceImg3}
                            alt="Step 02"
                            sx={{
                                position: "absolute",
                                top: "-45px",
                                left: "150px",
                                width: "50px",
                                height: "50px",
                                background: 'rgb(255, 210, 48)',
                                borderRadius: "50%",
                                padding: "15px 15px",
                            }}
                        />
                        <h3>Network of Vetted Partners</h3>
                        <div style={{ lineHeight: '2' }}>
                            Get access to our vetted partners for top quality services which will be required for your overall business growth. We've been working with these partners since long & have trust on their service quality, so you never have to worry finding right service providers.
                        </div>
                    </Box>
                </Box>
            </Box>


        </Box>
    );
};

export default Experience;
